const html = require("./html/asnShippingPalletRowsReview.html");
import {setElementsFromScope, swapClasses, insertValAndManageFocus, show, hide, handleDisplayFor} from "../../../utilities/selectorHelpers";
import {unbindAll, extractElements} from "../../../utilities/viewHelpers";
import _ from "underscore";
import $ from "jquery";
import AsnShippingPalletStore from "../../../stores/AsnShippingPalletStore";
import AsnStore from "../../../stores/AsnStore";
import AsnShippingPalletRowReview from "./AsnShippingPalletRowReview";

const elementsMap = {
  asnShipppingPalletRowsChildrenReviewEntry: ".asn-shipping-pallet-rows-children-review-entry-point",
  casePalletTitle: ".case-pallet-title"
}

export default function AsnShippingPalletRowsReview(_unused, {
  getAsn,
  getAsnShipppingPallets
}){
  const self = this;
  self._element = $();
  const els = {};
  let asnShippingPalletRowReviews = [];

  self.init = function(){
    render();
  }

  function setElements(){
    setElementsFromScope(els, elementsMap, self._element);
  }

  function setWidgets(){

  }

  self.getElement = function(){
    return self._element;
  }

  function update(){
    updateSelf();
    updateChildren();
  }

  function updateSelf(){
    // No self inputs
    updateCasePalletLabel();
  }

  function updateChildren(){
    console.log("Calling updateChildren");
    unbindAll(asnShippingPalletRowReview);
    asnShippingPalletRowReviews = renderasnShippingPalletRowReviews();
    els.asnDetailRowsChildrenReviewEntry.html(extractElements(asnShippingPalletRowReviews));
  }

  function updateCasePalletLabel(){
    let text = "Case";
    if(isPallet()){
      text = "Pallet";
    }
    els.casePalletTitle.text(text);
  }



  function bindStores(){
    AsnStore.bindListener("asns:shipping_method_changed", update);
    AsnDetailStore.bindListener("asn_shipping_pallet:add", update);
    AsnDetailStore.bindListener("asn_shipping_pallet:remove", update);
    AsnStore.bindListener("asns:change", updateSelf);
  }

  self.unbindListeners = function(){

  }

  function render(){
    self._element = $(html);
    setElements();
    setWidgets();
    update();
    bindStores();
  }


  function renderasnShippingPalletRowReviews(){
    return _(getAsnShipppingPallets()).map((asnShippingPallet, rowIdx)=>{
      // get the first asnDetail in the Pallet/case,
      // as all these values should be the same for the given
      // AsnDetailRowView
     
      const asnShippingPalletRowReview = new AsnShippingPalletView(asnShippingPallet, {
        rowIdx
      });
      asnShippingPalletRowReview.init();
      return asnShippingPalletRowReview;
    });
  }

}


// WEBPACK FOOTER //
// ./src/pages/asns/ReviewTab/AsnShippingPalletRowsReview.js